module.exports = __webpack_public_path__ + "static/media/icon-booth-rev-transportation.2f6499fd.svg";